import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import {
    UntypedFormBuilder,
    UntypedFormGroup,
    UntypedFormControl,
    Validators,
} from '@angular/forms';
import {
    StaffPosition,
    EmployeePositionService,
    IClientStaffPositionDdl,
    EmployeePositionLookupForm,
} from 'app/modules/settings/services/employee-position.service';
import { ToastService } from '../../services/toast.service';

@Component({
    selector: 'app-add-job-title-mapping-dialog',
    templateUrl: './add-job-title-mapping-dialog.component.html',
    styleUrls: ['./add-job-title-mapping-dialog.component.scss'],
})
export class AddJobTitleMappingDialogComponent implements OnInit {
    form: UntypedFormGroup;
    staffPositions: StaffPosition[];
    submitting: boolean;
    @Input() clientStaffPositions: IClientStaffPositionDdl[];
    @Output() saveSuccessful?: EventEmitter<any> = new EventEmitter<any>();
    @Output() closeClicked?: EventEmitter<any> = new EventEmitter<any>();
    jobTitleIsNotUnique: boolean;

    constructor(
        private formBuilder: UntypedFormBuilder,
        private positionService: EmployeePositionService,
        private toast: ToastService
    ) {}

    ngOnInit() {
        this.form = this.createFormGroup();
        this.getStaffPositions();
    }

    ngAfterViewInit() {
        document.getElementById('jobTitleInput').focus();
    }

    getStaffPositions() {
        this.positionService.getPositions().subscribe(
            (staffPositions) => {
                this.staffPositions = staffPositions;
            },
            (error) => {
                throw new Error(error);
            }
        );
    }
    createFormGroup(): UntypedFormGroup {
        return this.formBuilder.group({
            jobTitle: new UntypedFormControl('', [Validators.required, Validators.maxLength(100)]),
            jobCode: new UntypedFormControl('', [Validators.maxLength(5)]),
            staffPositionKey: new UntypedFormControl('', Validators.required),
        });
    }

    get jobTitle() {
        return this.form.get('jobTitle');
    }
    get jobCode() {
        return this.form.get('jobCode');
    }
    get staffPositionKey() {
        return this.form.get('staffPositionKey');
    }

    onSubmit() {
        this.submitting = true;
        this.form.markAsPristine();
        let newJobTitleModel: EmployeePositionLookupForm = {
            staffPositionKey: this.staffPositionKey.value,
            jobTitle: this.jobTitle.value,
            jobCode: this.jobCode.value,
        };
        this.positionService.updateEmployeePositionMapping([newJobTitleModel]).subscribe(
            (_) => {
                this.toast.success('Job title created.');
                this.submitting = false;
                this.saveSuccessful.emit(newJobTitleModel.jobTitle);
            },
            (error) => {
                this.submitting = false;
                this.toast.warning('Problem created job title.');
                throw new Error(error);
            }
        );
    }

    closeClickedHandler() {
        this.closeClicked.emit();
    }

    jobTitleChangeHandler() {
        this.jobTitleIsNotUnique = false;
        if (
            this.clientStaffPositions.some(
                (x) => x.clientPosition.toLowerCase() === this.jobTitle.value.toLowerCase()
            )
        ) {
            this.jobTitleIsNotUnique = true;
        }
    }
}
